/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateTenantRequest } from '../models/CreateTenantRequest';
import type { CreateTenantResponse } from '../models/CreateTenantResponse';
import type { GetTenantResponse } from '../models/GetTenantResponse';
import type { UpdateTenantRequest } from '../models/UpdateTenantRequest';
import type { UpdateTenantResponse } from '../models/UpdateTenantResponse';
import type { UpdateTenantStatusRequest } from '../models/UpdateTenantStatusRequest';
import type { UpdateTenantStatusResponse } from '../models/UpdateTenantStatusResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TenantControllerService {
    /**
     * @param tenantId
     * @param requestBody Update tenant status request
     * @returns UpdateTenantStatusResponse Update tenant status response
     * @throws ApiError
     */
    public static tenantControllerUpdateStatus(
        tenantId: number,
        requestBody?: UpdateTenantStatusRequest,
    ): CancelablePromise<UpdateTenantStatusResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v0/api/tenant/{tenantId}/status',
            path: {
                'tenantId': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param tenantId
     * @param requestBody Update tenant request
     * @returns UpdateTenantResponse Update tenant response
     * @throws ApiError
     */
    public static tenantControllerUpdate(
        tenantId: number,
        requestBody?: UpdateTenantRequest,
    ): CancelablePromise<UpdateTenantResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v0/api/tenant/{tenantId}',
            path: {
                'tenantId': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param tenantId
     * @returns GetTenantResponse Get tenant response
     * @throws ApiError
     */
    public static tenantControllerGetTenantDetails(
        tenantId: string,
    ): CancelablePromise<GetTenantResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/tenant/{tenantId}',
            path: {
                'tenantId': tenantId,
            },
        });
    }
    /**
     * @param tenantId
     * @returns any OK
     * @throws ApiError
     */
    public static tenantControllerDelete(
        tenantId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v0/api/tenant/{tenantId}',
            path: {
                'tenantId': tenantId,
            },
        });
    }
    /**
     * @param requestBody Create tenant request
     * @returns CreateTenantResponse Create tenant response
     * @throws ApiError
     */
    public static tenantControllerCreate(
        requestBody?: CreateTenantRequest,
    ): CancelablePromise<CreateTenantResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v0/api/tenant',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any List tenants response
     * @throws ApiError
     */
    public static tenantControllerListAllTenants(): CancelablePromise<Array<{
        id?: number;
        name?: string;
        shortCode?: string;
        tenantStatus?: {
            displayName?: string;
        };
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v0/api/tenants',
        });
    }
}
